import { z } from "zod";
import { assetFilterSchema } from "./common";

const localDateTime = z
  .string()
  .min(1, "required")
  .refine((v) => !Number.isNaN(Date.parse(v)), "must be a valid date/time");

/**
 * `POST /v1/maintenance-windows` body. Mirrors `CreateWindow` in routes_ops.rs.
 * `start_time`/`end_time` are validated here as parseable date/time strings; the
 * dialog converts the `datetime-local` input value to RFC3339 (`Date#toISOString`,
 * interpreted in the browser's local timezone) right before calling the SDK.
 */
export const createWindowSchema = z
  .object({
    name: z.string().trim().min(1, "name is required").max(200),
    timezone: z.string().trim().min(1, "timezone is required"),
    start_time: localDateTime,
    end_time: localDateTime,
    days_of_week: z.array(z.coerce.number().int().min(0).max(6)).optional(),
    asset_filter: assetFilterSchema.optional(),
    suppress_alerts: z.boolean().default(true),
    show_status_page: z.boolean().default(false),
  })
  .refine((v) => Date.parse(v.end_time) > Date.parse(v.start_time), {
    message: "end time must be after start time",
    path: ["end_time"],
  });
export type CreateWindowInput = z.infer<typeof createWindowSchema>;

export const WEEKDAY_LABELS = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"] as const;
